import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type {
  GetPersonalNoteResults,
  PostPersonalNote
} from "./personal-note.types";

export const GetPersonalNoteResult = {
  url: () => `/exam/getQuestionNote`,
  fn: async (request: GetPersonalNoteResults["request"]) => {
    const { data } = await gwtClient<GetPersonalNoteResults["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: GetPersonalNoteResult.url(),
      data: request.body
    });
    return data;
  },
  key: (request: GetPersonalNoteResults["request"]) => {
    return reject(
      [GetPersonalNoteResult.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: GetPersonalNoteResults["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: GetPersonalNoteResult.key(options.request),
    queryFn: () => GetPersonalNoteResult.fn(options.request)
  }),
  useQuery: (options: GetPersonalNoteResults["queryOptions"]) =>
    useQuery(GetPersonalNoteResult.query(options)),
  useMutation: (options?: GetPersonalNoteResults["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: GetPersonalNoteResult.fn
    })
};

export const PostPersonalNoteResult = {
  url: () => `/exam/updateQuestionNote`,
  fn: async (request: PostPersonalNote["request"]) => {
    const { data } = await gwtClient<PostPersonalNote["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: PostPersonalNoteResult.url(),
      data: request.body
    });
    return data;
  },
  key: (request: PostPersonalNote["request"]) => {
    return reject(
      [PostPersonalNoteResult.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: PostPersonalNote["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: PostPersonalNoteResult.key(options.request),
    queryFn: () => PostPersonalNoteResult.fn(options.request)
  }),
  useQuery: (options: PostPersonalNote["queryOptions"]) =>
    useQuery(PostPersonalNoteResult.query(options)),
  useMutation: (options?: PostPersonalNote["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: PostPersonalNoteResult.fn
    })
};
